/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import Tabla from '@infotrack/presentacion-componentes/tabla';
import React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { ITablaReferenciasVistaProps } from '../interfaces';
import { acciones, columnas, opciones } from './constantes';

const VistaReferencias: React.FunctionComponent<ITablaReferenciasVistaProps & InjectedIntlProps> = ({
    referenciass,
    cargarReferencias,
    confirmarEliminacion,
    intl,
    manejarFormulario,
}) => (
    <div>
        <Tabla
            columns={columnas(intl.formatMessage)}
            data={referenciass}
            actions={acciones(manejarFormulario, cargarReferencias, intl.formatMessage, confirmarEliminacion)}
            options={opciones}
        />
    </div>
);

export default injectIntl(VistaReferencias);
